import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { useLanguage } from '@/contexts/LanguageContext';

const FeaturesSection = () => {
  const { t } = useTranslation();
  const { direction } = useLanguage();

  const features = [
    {
      id: 1,
      title: t('featureTimeTitle'),
      description: t('featureTimeDesc'),
      icon: (
        <svg className="w-12 h-12 text-synagogue-gold" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
        </svg>
      ),
    },
    {
      id: 2,
      title: t('featureDateTitle'),
      description: t('featureDateDesc'),
      icon: (
        <svg className="w-12 h-12 text-synagogue-gold" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
        </svg>
      ),
    },
    {
      id: 3,
      title: t('featureContentTitle'),
      description: t('featureContentDesc'),
      icon: (
        <svg className="w-12 h-12 text-synagogue-gold" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
          <path fillRule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clipRule="evenodd" />
        </svg>
      ),
    },
    {
      id: 4,
      title: t('featureMobileTitle'),
      description: t('featureMobileDesc'),
      icon: (
        <svg className="w-12 h-12 text-synagogue-gold" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" d="M7 2a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zm3 14a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
        </svg>
      ),
    },
  ];

  return (
    <section id="features" className="py-20 bg-synagogue-light">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-synagogue-blue">
          {t('featuresTitle')}
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {features.map((feature) => (
            <div 
              key={feature.id} 
              className={`flex ${direction === 'rtl' ? 'md:flex-row-reverse' : 'md:flex-row'} items-start bg-white p-6 rounded-lg shadow-md`}
            >
              <div className="flex-shrink-0 mr-4">
                <div className="bg-synagogue-blue/10 p-3 rounded-full">
                  {feature.icon}
                </div>
              </div>
              <div className={direction === 'rtl' ? 'text-right ml-4' : 'text-left'}>
                <h3 className="text-xl font-semibold mb-2 text-synagogue-blue">
                  {feature.title}
                </h3>
                <p className="text-gray-600">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection; 